export default "__VITE_ASSET__DkbaXb_D__"